import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { Permission, PLATFORM_PERMISSIONS } from '../../../backend/src/auth/permissions/permission';
import { useUserContext } from '../Contexts/User';

export function usePlatformPermissionCheck(permission: Permission | Permission[], redirectPath = '/matters') {
  const { user } = useUserContext();
  const navigate = useNavigate();
  const permissions = Array.isArray(permission) ? permission : [permission];
  const allowed =
    user?.organisation?.isGlobalAdmin === true &&
    permissions.some((candidate) => PLATFORM_PERMISSIONS.has(candidate) && user.role.permissions.includes(candidate));

  useEffect(() => {
    if (user?.organisation !== undefined && !allowed) {
      navigate(redirectPath);
    }
  }, [allowed, user?.organisation, navigate, redirectPath]);
}
